import { Link } from 'react-router-dom'
import React from 'react'
import { makeStyles } from '@material-ui/core/styles'
const useStyles = makeStyles(theme => ({
  link: {
    color: '#0F5DB5',
    textDecoration: 'none',
    cursor: 'pointer',
  },
}))

export const OrganizationLinkCell = ({ value }: any) => {
  const { orgName, id } = value || {}
  const classes = useStyles()

  return id ? (
    <Link className={classes.link} to={`/organization/${id}`}>
      {orgName}
    </Link>
  ) : null
}
